import React from "react"

function PanelGroup(props) {
  return (
    <div className="slds-filters">
      <div className="slds-filters__body">
        {props.children}
      </div>
      <div className="slds-filters__footer slds-grid slds-shrink-none">
        <button className="slds-button_reset slds-text-link" type="button" onClick={props.onAdd}>
        {props.addLabel}</button>
        {props.removeAll ?
        (
          <button className="slds-button_reset slds-text-link slds-col_bump-left" type="button">Remove All</button>
        ) : (
          ''
        )
        }
      </div>
    </div>
  )
}

export default PanelGroup